import React from 'react';
import Text from './Text';
const ErrorText = props => props.children ? /*#__PURE__*/React.createElement(Text, props) : null;
ErrorText.propTypes = {};
ErrorText.defaultProps = {
  color: 'red'
};
ErrorText.displayName = 'ErrorText';
export default ErrorText;